// cart-drawer-toggle.js — unified PBCart + header badge & subtotal sync
(function () {
  const PRIMARY_SELECTOR = '[data-pb-cart-drawer="primary"]';
  const DRAWER_TRANSITION_MS = 380;

  function getPrimaryDrawer() {
    return (
      document.querySelector(PRIMARY_SELECTOR) ||
      document.getElementById('UnifiedCartDrawer')
    );
  }

  function removeDuplicateDrawers(primary) {
    if (!primary) return;

    document.querySelectorAll('.unified-cart-drawer').forEach((el) => {
      if (el === primary) return;
      el.remove();
    });
  }

  function init() {
    if (window.__pbCartDrawerToggleInit) return;
    window.__pbCartDrawerToggleInit = true;

    const drawer = getPrimaryDrawer();
    if (!drawer) return;

    removeDuplicateDrawers(drawer);

    let backdrop = document.querySelector('.ucd-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'ucd-backdrop';
      document.body.appendChild(backdrop);
    }

    let scrollY = 0;
    let closeTimer = 0;

    function lockScroll() {
      scrollY = window.scrollY;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    function unlockScroll() {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      window.scrollTo(0, scrollY);
    }

    function preserveScrollPosition() {
      window.scrollTo(0, scrollY);
    }

    function openDrawer() {
      if (drawer.classList.contains('is-open')) return;

      window.clearTimeout(closeTimer);
      scrollY = window.scrollY;
      lockScroll();

      if (window.PBOverlayStack) {
        window.PBOverlayStack.push(backdrop);
        window.PBOverlayStack.push(drawer);
      }

      preserveScrollPosition();

      document.documentElement.classList.add('ucd-cart-open');
      document.body.classList.add('ucd-cart-open');

      requestAnimationFrame(() => {
        void drawer.offsetWidth;
        backdrop.classList.add('is-visible');
        drawer.classList.add('is-open');
        preserveScrollPosition();
      });
    }

    function finishClose() {
      if (window.PBOverlayStack) {
        window.PBOverlayStack.pop(drawer);
        window.PBOverlayStack.pop(backdrop);
      }
      unlockScroll();
    }

    function closeDrawer() {
      if (!drawer.classList.contains('is-open')) return;

      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-visible');

      let finished = false;
      const complete = () => {
        if (finished) return;
        finished = true;
        drawer.removeEventListener('transitionend', onTransitionEnd);
        window.clearTimeout(closeTimer);
        document.documentElement.classList.remove('ucd-cart-open');
        document.body.classList.remove('ucd-cart-open');
        finishClose();
      };

      const onTransitionEnd = (event) => {
        if (event.target !== drawer || event.propertyName !== 'right') return;
        complete();
      };

      drawer.addEventListener('transitionend', onTransitionEnd);
      closeTimer = window.setTimeout(complete, DRAWER_TRANSITION_MS);
    }

    function toggleDrawer() {
      drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
    }

    window.PBGetCartDrawer = getPrimaryDrawer;
    window.PBCartDrawer = { open: openDrawer, close: closeDrawer, toggle: toggleDrawer };

    drawer.querySelector('.cart-drawer__close')?.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });

    document.addEventListener('cart:open', openDrawer);
    document.addEventListener('cart:close', closeDrawer);
    document.addEventListener('cart:toggle', toggleDrawer);

    const candidates = [
      'a[href$="/cart"]',
      '.header__icon--cart',
      '.header__cart',
      'button[data-open-cart]',
      '[data-header-cart]',
      '[data-cart-toggle]',
    ];
    const cartIcon = document.querySelector(candidates.join(','));
    cartIcon?.addEventListener('click', (ev) => {
      ev.preventDefault();
      openDrawer();
    });

    function formatEUR(amount) {
      try {
        return new Intl.NumberFormat('nl-NL', {
          style: 'currency',
          currency: 'EUR',
        }).format(amount);
      } catch {
        return `€${amount.toFixed(2).replace('.', ',')}`;
      }
    }

    document.addEventListener('pb:cart:updated', (e) => {
      const gqlCart = e.detail?.cart;

      if (e.detail?.source === 'addLine' || e.detail?.source === 'add') {
        setTimeout(() => openDrawer(), 60);
      }

      const countEl = document.querySelector('[data-cart-count],[data-header-cart-count]');
      if (countEl && gqlCart?.totalQuantity != null) {
        countEl.textContent = gqlCart.totalQuantity;
      }

      const subEl = document.querySelector('[data-cart-subtotal]');
      const sub = gqlCart?.cost?.subtotalAmount;
      if (subEl && sub?.amount) {
        subEl.textContent = formatEUR(parseFloat(sub.amount));
      }
    });

    const qs = new URLSearchParams(location.search);
    if (qs.get('viewcart') === 'true' || qs.get('cartopen') === 'true') openDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
